module.exports = __webpack_public_path__ + "img/2025-05-09c_2.bf57880f.jpg";